export default __webpack_public_path__ + "static/media/432.894ebc34.jpg";